import React from 'react';
import { useAuth } from '../../hooks/AuthContext';
import { FiClock, FiLogOut, FiCheckCircle, FiMail, FiLayers } from 'react-icons/fi';

const PendingApproval = () => {
  const { user, logout } = useAuth();

  const isRejected = user?.status === 'rejected';

  return (
    <div className="min-h-screen bg-[#0a0a0f] text-white flex items-center justify-center px-6">
      <div className="max-w-md w-full text-center">
        {/* Logo */}
        <div className="flex items-center gap-3 justify-center mb-10">
          <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-indigo-500 to-purple-600 flex items-center justify-center">
            <FiLayers size={20} />
          </div>
          <span className="text-xl font-bold">Hingenia Suite</span>
        </div>

        {/* Status icon */}
        <div className={`w-20 h-20 rounded-full mx-auto mb-6 flex items-center justify-center ${
          isRejected
            ? 'bg-red-500/10 ring-4 ring-red-500/10'
            : 'bg-amber-500/10 ring-4 ring-amber-500/10'
        }`}>
          {isRejected ? (
            <FiMail size={32} className="text-red-400" />
          ) : (
            <FiClock size={32} className="text-amber-400" />
          )}
        </div>

        <h1 className="text-2xl font-bold mb-3">
          {isRejected ? 'Solicitud no aprobada' : 'Pendiente de aprobacion'}
        </h1>

        <p className="text-gray-400 mb-2 leading-relaxed">
          Hola, <span className="text-white font-medium">{user?.displayName || user?.email}</span>.
        </p>

        {isRejected ? (
          <p className="text-gray-500 text-sm mb-8 leading-relaxed">
            Tu solicitud de registro no fue aprobada. Si crees que fue un error,
            contacta al administrador para mas informacion.
          </p>
        ) : (
          <>
            <p className="text-gray-500 text-sm mb-4 leading-relaxed">
              Tu empresa ha sido registrada exitosamente. Un administrador
              revisara tu solicitud y la aprobara pronto.
            </p>
            <div className="bg-white/5 rounded-xl border border-white/10 p-4 mb-8">
              <div className="flex items-center gap-3 text-sm">
                <FiCheckCircle size={18} className="text-emerald-400 flex-shrink-0" />
                <p className="text-gray-400 text-left text-xs">
                  Recibiras acceso automaticamente cuando tu empresa sea aprobada.
                  Solo recarga la pagina despues de la aprobacion.
                </p>
              </div>
            </div>
          </>
        )}

        <p className="text-xs text-gray-600 mb-6">
          Consultas: <span className="text-indigo-400">vcecursos@gmail.com</span>
        </p>

        <button
          onClick={logout}
          className="w-full py-3.5 bg-white/5 border border-white/10 rounded-xl text-sm font-medium text-gray-300 hover:bg-white/10 transition-all flex items-center justify-center gap-2"
        >
          <FiLogOut size={16} />
          Cerrar Sesion
        </button>
      </div>
    </div>
  );
};

export default PendingApproval;
